import React, { useState, useEffect } from "react";
import { useRange } from "react-instantsearch";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";

export default function RangeSlider({ attribute }) {
  const { start, range, canRefine, refine } = useRange({ attribute });

  // Algolia/Searchkit nous fournit les valeurs min/max de date
  const min = range.min !== undefined ? range.min : 1838;
  const max = range.max !== undefined ? range.max : new Date().getFullYear();

  const [value, setValue] = useState([min, max]);
  const [inputDebut, setInputDebut] = useState(min);
  const [inputFin, setInputFin] = useState(max);

  useEffect(() => {
    // Si la recherche active un min/max particulier, on le mappe
    const valMin = start[0] !== -Infinity && start[0] !== undefined ? start[0] : min;
    const valMax = start[1] !== Infinity && start[1] !== undefined ? start[1] : max;
    
    setValue([valMin, valMax]);
    setInputDebut(valMin);
    setInputFin(valMax);
  }, [start, min, max]);

  if (!canRefine || min === max) {
    return null; // Rien à filtrer ou valeurs incorrectes
  }

  const handleChange = (event, newValue) => {
    if (newValue[0] === newValue[1]) {
      newValue[0] = newValue[0] - 1;
    }
    setValue(newValue);
  };

  const handleCommit = (event, newValue) => {
    refine(newValue); // Met à jour la recherche
  };

  const handleInputDebut = (e) => {
    const val = Number(e.target.value);
    setInputDebut(val);
    if (val <= value[1]) {
      refine([val, value[1]]);
    }
  };

  const handleInputFin = (e) => {
    const val = Number(e.target.value);
    setInputFin(val);
    const currentYear = new Date().getFullYear();
    if (val <= currentYear && val >= value[0]) {
      refine([value[0], val]);
    }
  };

  return (
    <Box sx={{ width: "auto", marginLeft: 1, marginBottom: 3, marginTop: 0 }}>
      <div className="sui-multi-checkbox-facet__option-count" style={{ marginTop: -15, textAlign: "right" }}>
        <input
          name="rangeDebut"
          type="number"
          className="sui-facet__title"
          style={{ width: "50px", borderWidth: "0 0 1px 0", borderColor: "#ddd" }}
          onChange={handleInputDebut}
          value={inputDebut}
        />-
        <input
          name="rangeFin"
          type="number"
          className="sui-facet__title"
          style={{ width: "50px", borderWidth: "0 0 1px 0", borderColor: "#ddd" }}
          onChange={handleInputFin}
          value={inputFin}
        />
      </div>
      <Slider
        name={attribute}
        getAriaLabel={() => "Période"}
        size="small"
        min={min}
        max={max}
        value={value}
        onChange={handleChange}
        onChangeCommitted={handleCommit}
        valueLabelDisplay="off"
        disableSwap
      />
    </Box>
  );
}
